const option = [
    { id: 'LAZADA', name: 'LAZADA' },
    { id: 'SHOPEE', name: 'SHOPEE' },
    { id: 'TEL', name: 'จองผ่านโทรศัพท์' }
]

export default {
    option: option
};